module.exports = __webpack_public_path__ + "static/media/project-thumbnail04.971787da.jpg";